import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StatesService {

  constructor() { }

  getStates() {
    return [
      {
        id: 1,
        clave: "01",
        nombre: "Aguascalientes",
        abrev: "Ags.",
        activo: 1
      },
      {
        id: 2,
        clave: "02",
        nombre: "Baja California",
        abrev: "BC",
        activo: 1
      },
      {
        id: 3,
        clave: "03",
        nombre: "Baja California Sur",
        abrev: "BCS",
        activo: 1
      },
      {
        id: 4,
        clave: "04",
        nombre: "Campeche",
        abrev: "Camp.",
        activo: 1
      },
      {
        id: 5,
        clave: "05",
        nombre: "Coahuila de Zaragoza",
        abrev: "Coah.",
        activo: 1
      },
      {
        id: 6,
        clave: "06",
        nombre: "Colima",
        abrev: "Col.",
        activo: 1
      },
      {
        id: 7,
        clave: "07",
        nombre: "Chiapas",
        abrev: "Chis.",
        activo: 1
      },
      {
        id: 8,
        clave: "08",
        nombre: "Chihuahua",
        abrev: "Chih.",
        activo: 1
      },
      {
        id: 9,
        clave: "09",
        nombre: "Ciudad de México",
        abrev: "CDMX",
        activo: 1
      },
      {
        id: 10,
        clave: "10",
        nombre: "Durango",
        abrev: "Dgo.",
        activo: 1
      },
      {
        id: 11,
        clave: "11",
        nombre: "Guanajuato",
        abrev: "Gto.",
        activo: 1
      },
      {
        id: 12,
        clave: "12",
        nombre: "Guerrero",
        abrev: "Gro.",
        activo: 1
      },
      {
        id: 13,
        clave: "13",
        nombre: "Hidalgo",
        abrev: "Hgo.",
        activo: 1
      },
      {
        id: 14,
        clave: "14",
        nombre: "Jalisco",
        abrev: "Jal.",
        activo: 1
      },
      {
        id: 15,
        clave: "15",
        nombre: "México",
        abrev: "Mex.",
        activo: 1
      },
      {
        id: 16,
        clave: "16",
        nombre: "Michoacán de Ocampo",
        abrev: "Mich.",
        activo: 1
      },
      {
        id: 17,
        clave: "17",
        nombre: "Morelos",
        abrev: "Mor.",
        activo: 1
      },
      {
        id: 18,
        clave: "18",
        nombre: "Nayarit",
        abrev: "Nay.",
        activo: 1
      },
      {
        id: 19,
        clave: "19",
        nombre: "Nuevo León",
        abrev: "NL",
        activo: 1
      },
      {
        id: 20,
        clave: "20",
        nombre: "Oaxaca",
        abrev: "Oax.",
        activo: 1
      },
      {
        id: 21,
        clave: "21",
        nombre: "Puebla",
        abrev: "Pue.",
        activo: 1
      },
      {
        id: 22,
        clave: "22",
        nombre: "Querétaro",
        abrev: "Qro.",
        activo: 1
      },
      {
        id: 23,
        clave: "23",
        nombre: "Quintana Roo",
        abrev: "Q. Roo",
        activo: 1
      },
      {
        id: 24,
        clave: "24",
        nombre: "San Luis Potosí",
        abrev: "SLP",
        activo: 1
      },
      {
        id: 25,
        clave: "25",
        nombre: "Sinaloa",
        abrev: "Sin.",
        activo: 1
      },
      {
        id: 26,
        clave: "26",
        nombre: "Sonora",
        abrev: "Son.",
        activo: 1
      },
      {
        id: 27,
        clave: "27",
        nombre: "Tabasco",
        abrev: "Tab.",
        activo: 1
      },
      {
        id: 28,
        clave: "28",
        nombre: "Tamaulipas",
        abrev: "Tamps.",
        activo: 1
      },
      {
        id: 29,
        clave: "29",
        nombre: "Tlaxcala",
        abrev: "Tlax.",
        activo: 1
      },
      {
        id: 30,
        clave: "30",
        nombre: "Veracruz de Ignacio de la Llave",
        abrev: "Ver.",
        activo: 1
      },
      {
        id: 31,
        clave: "31",
        nombre: "Yucatán",
        abrev: "Yuc.",
        activo: 1
      },
      {
        id: 32,
        clave: "32",
        nombre: "Zacatecas",
        abrev: "Zac.",
        activo: 1
      }
    ]
  }
}
